import React from "react";
import { I18n } from "@aws-amplify/core";
import update from "immutability-helper";
import { get, flatten, map, filter } from "lodash";

import Grid from "@material-ui/core/Grid";

import InfoSection from "../../Common/InfoSection";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import FormSection from "../../Common/FormSection";
import CustomButton from "../../Common/CustomButton";
import { fetchPut } from "../../../api/fetch";

const ProfileLocation = (props) => {
  const { /*itemSizes, profileType,*/ profile, user, refresh } = props;
  const [editMode, setEditMode] = React.useState(false);
  const [formValues, setFormValues] = React.useState({});

  const currentSite = get(
    filter(
      flatten(map(get(user, ["companies"]), (c) => c.sites)),
      (s) => s.id === get(profile, ["current_loc_site_id"])
    ),
    [0]
  );

  const currentZone = get(
    filter(
      get(
        filter(
          flatten(map(get(user, ["companies"]), (c) => c.sites)),
          (s) => s.id === get(profile, ["current_loc_site_id"])
        ),
        [0, "zones"]
      ),
      (z) => z.id === get(profile, ["current_loc_zone_id"])
    ),
    [0]
  );

  React.useEffect(() => {
    if (editMode) {
      setFormValues({
        current_loc_site_id: get(currentSite, ["id"]),
        current_loc_zone_id: get(currentZone, ["id"]),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editMode]);

  const handleChange = (id, index, value) => {
    let newValues = update(formValues, {
      [id]: { $set: value },
    });
    if (id === "current_loc_site_id") {
      newValues.current_loc_zone_id = null;
    }
    if (id === "current_loc_zone_id" && value === null) {
      newValues.current_loc_site_id = null;
    }
    setFormValues(newValues);
  };

  const submit = async () => {
    try {
      await fetchPut(`onsite/${get(profile, ["id"])}`, {
        current_loc_zone_id: get(formValues, ["current_loc_zone_id"]),
      });
      setEditMode(false);
      refresh();
    } catch (e) {
      console.log(e);
    }
  };

  const itemSize = "220px";

  return (
    <Grid
      container
      style={{
        marginTop: "20px",
        maxWidth: editMode ? "930px" : "770px",
        backgroundColor: colors.lightGrey,
      }}
    >
      <Grid
        item
        style={{
          backgroundColor: colors.lightGrey,
          paddingTop: "10px",
        }}
      >
        <Grid
          container
          alignItems="center"
          style={{ paddingBottom: "10px", height: "100%" }}
        >
          <Grid
            item
            className="flexCenter"
            style={{
              justifyContent: "center",
              width: "50px",
              marginRight: "8px",
            }}
          >
            <img src={images.locationIcon} alt="user_login" />
          </Grid>
          <Grid
            item
            className="bold-500"
            style={{ lineHeight: "15px", width: "212px" }}
          >
            {I18n.get("profiles_currentlyLocatedIn")}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        style={{
          maxWidth: itemSize,
          width: itemSize,
          backgroundColor: colors.lightGrey,
          paddingTop: "10px",
        }}
      >
        <Grid container direction="column" style={{ paddingRight: "20px" }}>
          {editMode ? (
            <>
              <FormSection
                formValue={[get(formValues, ["current_loc_site_id"])]}
                setFormValue={handleChange}
                title="site"
                id={"current_loc_site_id"}
                type="select"
                options={{
                  categories: true,
                  options: map(get(user, ["companies"]), (c) => ({
                    ...c,
                    options: get(c, ["sites"]),
                  })),
                }}
              />
              <div style={{ textAlign: "right" }}>
                <CustomButton
                  color="primary"
                  onClick={() =>
                    handleChange("current_loc_zone_id", null, null)
                  }
                  style={{ marginTop: "-26px" }}
                >
                  {I18n.get("profiles_notOnSite")}
                </CustomButton>
              </div>
            </>
          ) : (
            <InfoSection title="site" values={[get(currentSite, ["name"])]} />
          )}
        </Grid>
      </Grid>
      <Grid
        item
        style={{
          maxWidth: itemSize,
          width: itemSize,
          backgroundColor: colors.lightGrey,
          paddingTop: "10px",
        }}
      >
        <Grid container direction="column" style={{ paddingRight: "20px" }}>
          {editMode ? (
            <FormSection
              formValue={[get(formValues, ["current_loc_zone_id"])]}
              setFormValue={handleChange}
              title="zone"
              id={"current_loc_zone_id"}
              type="select"
              options={{
                options: map(
                  get(
                    filter(
                      flatten(map(get(user, ["companies"]), (c) => c.sites)),
                      (s) => s.id === get(formValues, ["current_loc_site_id"])
                    ),
                    [0, "zones"]
                  ),
                  (z) => ({
                    id: z.id,
                    name: z.name,
                  })
                ),
              }}
            />
          ) : (
            <InfoSection title="zone" values={[get(currentZone, ["name"])]} />
          )}
        </Grid>
      </Grid>
      <Grid
        item
        xs
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          paddingRight: "20px",
          backgroundColor: colors.lightGrey,
          minWidth: "18px",
        }}
      >
        {editMode ? (
          <>
            <CustomButton
              color="primary"
              onClick={() => setEditMode(false)}
              style={{ marginRight: "20px" }}
            >
              {I18n.get("site_cancel")}
            </CustomButton>
            <CustomButton color="primary" variant="contained" onClick={submit}>
              {I18n.get("account_update")}
            </CustomButton>
          </>
        ) : !props.editDisabled ? (
          <img
            src={images.editIconColored}
            alt="edit"
            style={{ cursor: "pointer" }}
            onClick={() => setEditMode(true)}
          />
        ) : null}
      </Grid>
    </Grid>
  );
};

export default ProfileLocation;
